"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lottie_light = _interopRequireDefault(require("lottie-web/build/player/lottie_light"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Callback on lottie animation completed
 *
 * @callback onComplete
 */

/**
 * @typedef {Object} RefType
 * @property {Object} current
 * @property {() => void} current.play
 * @property {() => void} current.stop
 * @property {AnimationItem} current.anim
 */

/**
 * @typedef {Object} LottieOptions
 * @property {Object} animationData
 * @property {boolean} loop
 * @property {boolean} autoplay
 * @property {Object} [rendererSettings]
 * @property {string} [rendererSettings.preserveAspectRatio]
 */

/**
 * @typedef {Object} Props
 * @property {LottieOptions} options - Lottie's options, please refer to the README.md
 * @property {Object} [style] - React component style(s)
 * @property {number} [width] - width of the container component
 * @property {number} [height] - height of the container component
 * @property {boolean} [isClickToPauseDisabled]
 * @property {boolean} [isStopped]
 * @property {onComplete} [onComplete]
 * @property {string} [className]
 * @property {boolean} [isPaused]
 * @property {Array} [segments]
 * @property {number} [speed]
 * @property {number} [direction]
 * @property {RefType} [ref]
 */

/**
 * React component for `lottie-web`
 *
 * @type {React.FC<Props>}
 */
var Lottie = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var options = _ref.options,
    style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    isClickToPauseDisabled = _ref.isClickToPauseDisabled,
    isStopped = _ref.isStopped,
    onComplete = _ref.onComplete,
    className = _ref.className,
    isPaused = _ref.isPaused,
    segments = _ref.segments,
    speed = _ref.speed,
    direction = _ref.direction;
  var containerRef = (0, _react.useRef)();
  var _anim = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var _anim$current, _anim$current2, _anim$current3, _anim$current4, _anim$current5, _anim$current6, _anim$current7, _anim$current8;
    var loop = options.loop,
      autoplay = options.autoplay,
      animationData = options.animationData,
      rendererSettings = options.rendererSettings;
    var m_opt = _objectSpread(_objectSpread({}, options), {}, {
      container: containerRef.current,
      renderer: "svg",
      loop: loop !== false,
      autoplay: autoplay !== false,
      animationData: animationData,
      rendererSettings: rendererSettings
    });
    var animationCallback = function animationCallback() {
      if (onComplete) {
        onComplete();
      }
    };
    _anim.current = _lottie_light.default.loadAnimation(m_opt);
    if (isStopped) (_anim$current = _anim.current) === null || _anim$current === void 0 ? void 0 : _anim$current.stop();else if (segments) (_anim$current2 = _anim.current) === null || _anim$current2 === void 0 ? void 0 : _anim$current2.playSegments(segments);else (_anim$current3 = _anim.current) === null || _anim$current3 === void 0 ? void 0 : _anim$current3.play();
    (_anim$current4 = _anim.current) === null || _anim$current4 === void 0 ? void 0 : _anim$current4.setSpeed(speed);
    if (isPaused && !((_anim$current5 = _anim.current) !== null && _anim$current5 !== void 0 && _anim$current5.isPaused)) (_anim$current6 = _anim.current) === null || _anim$current6 === void 0 ? void 0 : _anim$current6.pause();
    if (direction) (_anim$current7 = _anim.current) === null || _anim$current7 === void 0 ? void 0 : _anim$current7.setDirection(direction);
    (_anim$current8 = _anim.current) === null || _anim$current8 === void 0 ? void 0 : _anim$current8.addEventListener("complete", animationCallback);
    return function () {
      var _anim$current9, _anim$current10;
      (_anim$current9 = _anim.current) === null || _anim$current9 === void 0 ? void 0 : _anim$current9.removeEventListener("complete", animationCallback);
      (_anim$current10 = _anim.current) === null || _anim$current10 === void 0 ? void 0 : _anim$current10.destroy();
    };
  }, [direction, isPaused, isStopped, onComplete, options, segments, speed]);

  /**
   * Handling pause animation on component getting
   * clicked
   */
  var handleClickToPause = function handleClickToPause() {
    var _anim$current11;
    if ((_anim$current11 = _anim.current) !== null && _anim$current11 !== void 0 && _anim$current11.isPaused) {
      var _anim$current12;
      (_anim$current12 = _anim.current) === null || _anim$current12 === void 0 ? void 0 : _anim$current12.play();
    } else {
      var _anim$current13;
      (_anim$current13 = _anim.current) === null || _anim$current13 === void 0 ? void 0 : _anim$current13.pause();
    }
  };

  // paused and anim used for testing purpose
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      paused: function paused() {
        var _anim$current14;
        return (_anim$current14 = _anim.current) === null || _anim$current14 === void 0 ? void 0 : _anim$current14.isPaused;
      },
      anim: function anim() {
        return _anim.current;
      },
      play: function play(name) {
        var _anim$current15;
        (_anim$current15 = _anim.current) === null || _anim$current15 === void 0 ? void 0 : _anim$current15.play(name);
      },
      stop: function stop(name) {
        var _anim$current16;
        (_anim$current16 = _anim.current) === null || _anim$current16 === void 0 ? void 0 : _anim$current16.stop(name);
      }
    };
  });

  /**
   * Parse size into style's size
   *
   * @param {any} initial size to parse
   * @returns parsed size
   */
  var getSize = function getSize(initial) {
    var size;
    if (typeof initial === "number") {
      size = "".concat(initial, "px");
    } else {
      size = initial || "100%";
    }
    return size;
  };
  var lottieStyles = _objectSpread({
    width: getSize(width),
    height: getSize(height),
    overflow: "hidden",
    margin: "0 auto",
    outline: "none"
  }, style);
  var onClickHandler = isClickToPauseDisabled ? function () {} : handleClickToPause;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    className: className,
    style: lottieStyles,
    onClick: onClickHandler,
    tabIndex: "0",
    "data-testid": "lottie-container"
  });
});
Lottie.propTypes = {
  isStopped: _propTypes.default.bool,
  isPaused: _propTypes.default.bool,
  speed: _propTypes.default.number,
  options: _propTypes.default.object.isRequired,
  style: _propTypes.default.object,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  isClickToPauseDisabled: _propTypes.default.bool,
  onComplete: _propTypes.default.func,
  className: _propTypes.default.string,
  segments: _propTypes.default.array,
  direction: _propTypes.default.number
};
Lottie.defaultProps = {
  isStopped: false,
  isPaused: false,
  speed: 1,
  isClickToPauseDisabled: true
};
var _default = Lottie;
exports.default = _default;